// extracted by mini-css-extract-plugin
module.exports = {"Loader":"scheme_Loader__ZAej7","Wrapper":"scheme_Wrapper__4_ZUz"};